import { useSelector } from 'react-redux';
import { SlideOutWrapper } from './SlideOutWrapper';
import TaxCard from '../taxes/Taxes/TaxCard';
import { UnsavedChangesConfirmationModal, useGetDrawerWidth, useUnsavedChangesModal } from '@makemydeal/dr-dash-components';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { getReturnToOfferButton } from '@makemydeal/dr-shared-ui-utils';

import type { SlideOutComponentProps } from '../../types';

export const TaxesSlideOut = ({ isOpen, onClose }: SlideOutComponentProps) => {
    const panelWidth = useGetDrawerWidth({
        extraLarge: 690,
        large: 690,
        tablet: 690
    });

    const taxItems = useSelector(offerReduxSelectors.getTaxItemsWithOverrides);

    const {
        isDirtyRef: isTaxesFormDirtyRef,
        showConfirmationModal,
        handleClose,
        handleCancelChanges,
        handleContinueEditing
    } = useUnsavedChangesModal({
        savedData: taxItems,
        onClose
    });

    return (
        <>
            <SlideOutWrapper
                title={'Taxes'}
                isOpen={isOpen}
                onClose={handleClose}
                panelWidth={panelWidth}
                testId="tab-slideout-taxes"
                footer={getReturnToOfferButton(handleClose)}
            >
                <TaxCard isInsideSlideOut isTaxesFormDirtyRef={isTaxesFormDirtyRef} />
            </SlideOutWrapper>
            <UnsavedChangesConfirmationModal
                show={showConfirmationModal}
                onCancelChanges={handleCancelChanges}
                onContinueEditing={handleContinueEditing}
            />
        </>
    );
};
